import { recipe } from '@vanilla-extract/recipes';
import { styleVariants } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

const tonePalette = {
  neutral: {
    background: vars.surface.highlight.faint,
    color: vars.typography.textColor.secondary,
    border: vars.surface.border.secondary,
  },
  active: {
    background: vars.stateColor.success.light,
    color: vars.bright.status.success,
    border: vars.stateColor.success.border,
  },
  inactive: {
    background: vars.surface.highlight.faint,
    color: vars.typography.textColor.tertiary,
    border: vars.surface.border.secondary,
  },
  urgent: {
    background: vars.stateColor.error.light,
    color: vars.bright.status.error,
    border: vars.stateColor.error.border,
  },
  warning: {
    background: vars.stateColor.warning.light,
    color: vars.bright.status.warning,
    border: vars.stateColor.warning.border,
  },
  info: {
    background: vars.stateColor.info.light,
    color: vars.bright.status.info,
    border: vars.stateColor.info.border,
  },
  const: {
    background: vars.surface.constellation.soft,
    color: vars.bright.rarity.constellation,
    border: vars.surface.constellation.border,
  },
} as const;

export const pillTone = styleVariants(tonePalette, (t) => ({
  background: t.background,
  color: t.color,
  border: `1px solid ${t.border}`,
}));

export const pillRecipe = recipe({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: vars.spacing.gap.xs,
    fontFamily: vars.typography.fontFamily.primary,
    fontWeight: vars.typography.fontWeight.semibold,
    letterSpacing: '-0.005em',
    borderRadius: vars.spacing.borderRadius.full,
    whiteSpace: 'nowrap',
    lineHeight: 1,
  },

  variants: {
    size: {
      sm: {
        padding: '4px 8px',
        fontSize: vars.typography.fontSize['2xs'],
      },
      md: {
        padding: '6px 10px',
        fontSize: vars.typography.fontSize.xs,
      },
      lg: {
        padding: '8px 12px',
        fontSize: vars.typography.fontSize.sm,
      },
    },
  },

  defaultVariants: {
    size: 'sm',
  },
});
